import React, { Component } from 'react';
import { shape, number, string } from 'prop-types';
import classnames from 'classnames';
import _includes from 'lodash/includes';
import { Proportion, Loader } from 'wix-style-react';
import {
  MAX_CHARS_IN_PORTFOLIO_HOVER_DESCRIPTION,
  KeyCode,
} from '../../../utils/constants';
import s from './portfolioItem.scss';
import { ServicesProvider } from '@wix/experts-common';

class PortfolioItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      isError: false,
      isFocused: false,
      isFocusOnSiteUrlElement: false,
    };
  }

  projectThumbnail = this.props.uploadImage || this.props.thumbnail;
  isUserUpload = !!this.props.uploadImage;
  intervalCounter = 0;
  interval;

  componentDidMount() {
    this.interval = setInterval(() => {
      this.intervalCounter++;
      if (
        this.intervalCounter === 5 &&
        !this.state.isLoaded &&
        !this.state.isError
      ) {
        this.setState({ isLoaded: true });
        clearInterval(this.interval);
      } else if (this.state.isLoaded || this.state.isError) {
        clearInterval(this.interval);
      }
    }, 200);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getProjectThumbnail = () => {
    const originalSize = `_crp_300_0_1300_800_${this.props.imgDimensions.w}_${this.props.imgDimensions.h}_crp`;
    const originalSizeUpload = `/v1/fill/w_${this.props.imgDimensions.w},h_${this.props.imgDimensions.h},q_80/file.jpg`;
    let src = this.projectThumbnail;
    if (this.isUserUpload && !_includes(src, '_OLD_THUMBNAIL')) {
      src += !_includes(src, '.wixmp.com') ? originalSizeUpload : '';
    } else if (this.props.metaSiteId) {
      src = `https://www.wix.com/site-thumbnail/${this.props.metaSiteId}?w=${this.props.imgDimensions.w}&h=${this.props.imgDimensions.h}`;
    } else {
      src = src.replace('_OLD_THUMBNAIL', '');
      src += originalSize;
    }
    return src;
  };

  handleLinkClicked = () => {
    this.context.services.withBI({
      evid: 29,
      typeid: 1,
      proGuid: this.props.expertGuid,
      siteLocationId: this.props.siteLocationId,
      url: this.props.siteUrl,
      siteGuid: this.props.thumbnail,
      origin: this.props.origin,
    });
    this.setState({ isFocusOnSiteUrlElement: false });
  };

  onFocus = () => {
    this.setState({ isFocused: true, isFocusOnSiteUrlElement: false });
  };

  onBlur = () => {
    !this.state.isFocusOnSiteUrlElement &&
      this.setState({ isFocused: false, isFocusOnSiteUrlElement: false });
  };

  render() {
    const {
      siteName,
      description,
      siteUrl,
      className,
      style,
      imgDimensions,
      staticsBaseUrl,
    } = this.props;
    const { isLoaded, isFocused } = this.state;
    const siteDescription =
      description.length > 50
        ? description.substring(0, MAX_CHARS_IN_PORTFOLIO_HOVER_DESCRIPTION) +
          '...'
        : description;

    return (
      <div
        tabIndex={0}
        className={classnames(s.portfolioItem, className)}
        style={style}
        data-hook="portfolio-item"
        onMouseEnter={this.onFocus}
        onMouseLeave={this.onBlur}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onKeyDown={event => {
          if (!event.shiftKey && event.keyCode === KeyCode.Tab) {
            this.setState({ isFocusOnSiteUrlElement: true });
          }
        }}
      >
        <Proportion
          dataHook="portfolio-item-proportion"
          aspectRatio={imgDimensions.w / imgDimensions.h}
        >
          <img
            data-hook="portfolio-item-img"
            src={this.getProjectThumbnail()}
            alt={`${siteName} ${siteDescription}`}
            onLoad={() => {
              this.setState({ isLoaded: true });
            }}
            onError={e => {
              if (!this.state.isError) {
                this.setState({ isError: true });
                e.target.onerror = null;
                e.target.src = `${staticsBaseUrl}/assets/images/site-not-published.svg`;
              }
            }}
          />
          <div
            className={`${s.projectItemHoverLayer} ${
              isFocused ? s.focused : ''
            }`}
            data-hook="portfolio-item-hover-layer"
            onClick={
              siteUrl
                ? () => {
                    this.handleLinkClicked();
                    window.open(siteUrl, '_blank');
                  }
                : undefined
            }
          >
            <div className={s.siteName} data-hook="portfolio-item-site-name">
              {siteName}
            </div>
            <div
              className={s.description}
              data-hook="portfolio-item-description"
            >
              {siteDescription}
            </div>
            {siteUrl && (
              <a
                tabIndex={isFocused ? 0 : -1}
                href={siteUrl}
                onClick={this.handleLinkClicked}
                onKeyUp={event => {
                  event.keyCode === KeyCode.Enter && this.handleLinkClicked();
                }}
                onKeyDown={event => {
                  if (event.keyCode === KeyCode.Tab) {
                    this.setState({
                      isFocused: event.shiftKey,
                      isFocusOnSiteUrlElement: false,
                    });
                  }
                }}
                target="_blank"
                data-hook="portfolio-item-link"
                className={s.link}
              />
            )}
          </div>
          {!isLoaded && (
            <div className={s.loader} data-hook="portfolio-item-loader">
              <Loader size="small" />
            </div>
          )}
        </Proportion>
      </div>
    );
  }
}

PortfolioItem.propTypes = {
  siteName: string,
  description: string,
  siteUrl: string,
  thumbnail: string,
  uploadImage: string,
  imgDimensions: shape({ w: number, h: number }),
  origin: string,
  expertGuid: string,
  metaSiteId: string,
};

PortfolioItem.defaultProps = {
  siteName: '',
  description: '',
};

PortfolioItem.contextTypes = ServicesProvider.childContextTypes;
export default PortfolioItem;
